/**
 *Created by jmmartinez on 10/02/20
 *  v.1.1 15/04/2020 Añadida propiedad usuario a los métodos loadDefinicioif, loadConfiguracion y saveConfiguracion
 *  v.1.2 29/04/2020 Añadido método getColumnasDesdeDefinicionesif para usar las definiciones del react.
 *  v.2.0 30/09/2020 Cambiado a framework2
 *  v.2.1 06/08/2021 El método configurarColumnas se renombra a generarColumnasEstado.
 *                   En el método generarColumnasEstado, se cambia la asignación a visible: columnaActual ? columnaActual.visible : false
 *  v.2.2 09/08/2021 Nueva versión completa.
 *  v.2.2 10/08/2021 Modificaciones para la gestión de orden.
 *
 *  v.2.3 03/05/2022 Unificacion sidemur - planifikator
 *  v.2.4 19/05/2022 Modificado generarColumnasDesdeColumnasEstado, para controlar el caso en el que no se encuentre columna Original
 *  v.2.5 19/12/2022 Modificado generarColumnasEstado:
 *                      Modificada la forma de calcular si es visible la columna.
 *                      Para calcular el orden, comprobamos la nulidad de columnaActual.
 * */

import {servidor} from "../../../dental/Configuracion";
import ClienteRestful from "../network/ClienteRestful";
import {FILTRO_IGUAL} from "../UI/FormularioGridBusqueda";
import {primerElementoConValorPropiedad} from "./ArrayUtils"
import {COLUMNVISIBLE_NUNCA, COLUMNVISIBLE_SIEMPRE, COLUMNVISIBLE_VARIABLE} from "../UI/TiposCeldas";


//Obtenemos las columnasEstado por comparación entre las columnas originales y las columnas actuales
export const generarColumnasEstado = (columnasOriginales, columnasActuales, anchosColumnas) => {
    console.log("+++ generarColumnasEstado +++")
    let columnasEstado= [];
    console.log("columnasOriginales: ", columnasOriginales);
    console.log("columnasActuales: ", columnasActuales);
    console.log("anchosColumnas: ", anchosColumnas);
    columnasOriginales.forEach( (columna, index) => {
        console.log(" * columna: ", columna);
        console.log("campo: ", columna.campo);
        let columnaActual = primerElementoConValorPropiedad(columnasActuales, "campo", columna.campo);
        console.log("columnaActual: ", columnaActual);

        let visible= true;
        if (columnaActual)
            visible= columnaActual.visible;
        else{
            switch (columna.visibilidad){
                case COLUMNVISIBLE_SIEMPRE: visible= true; break;
                case COLUMNVISIBLE_NUNCA: visible= false; break;
                default: visible= true;
            }
        }
        columnasEstado.push(
            {
                campo: columna.campo,
                titulo: columna.titulo,
                visible: visible,
                visibilidad: columna.visibilidad ? columna.visibilidad : COLUMNVISIBLE_SIEMPRE, //COLUMNVISIBLE_VARIABLE,
                ancho: anchosColumnas[columna.campo],
                orden: columnaActual ? columnaActual.orden : 0,
            }
        );
    });
    return columnasEstado;
}


export const ordenarColumnasEstado= (columnasEstado) => {
    columnasEstado.sort(function (a, b) {
        if (a.orden > b.orden) {
            return 1;
        }
        if (a.orden < b.orden) {
            return -1;
        }
        return 0;
    });

    columnasEstado.forEach( (columnaEstado, index) => {
        columnaEstado.orden= index;
    });

    return columnasEstado;
}

//Devolvemos las nuevas columnas a partir de las originales y de las columnas de Estado
export const generarColumnasDesdeColumnasEstado = (columnasEstado, columnasOriginales) => {
    let newColumnas=[];
    columnasEstado.forEach((columnaEstado) => {
        if (columnaEstado && columnaEstado.visible === true) {
            let campo= columnaEstado.campo;
            //let newColumna= {...primerElementoConValorPropiedad(columnasOriginales, "campo", campo)};
            let columnaOriginal= primerElementoConValorPropiedad(columnasOriginales, "campo", campo);
            if (columnaOriginal){
                let newColumna= {...columnaOriginal};
                newColumna.ancho= columnaEstado.ancho;
                newColumnas.push(newColumna);
            }
        }
    });
    return newColumnas;
}



//Obtenemos un objeto con el alto y las nuevas columnas desde los daltos del props de Redux
export const getConfiguracionGridFromConfiguracionRedux = (definicionesifRedux, ifid, columnasOriginales) => {
    //console.log("definicionesifRedux: ", definicionesifRedux);
    let definicionif= definicionesifRedux[ifid];
    if (definicionif) {
        let nuevasColumnas = generarColumnasDesdeColumnasEstado(definicionif.columns, columnasOriginales);
        let alto= definicionif.alto;
        return {columnas: nuevasColumnas, alto: alto};
    }

}



//
export const crearDefinicion = (ifid, alto, columnasOriginales) =>{
    let columnas= [];
    columnasOriginales.forEach ((columnaOriginal, index) => {
        let columna= {
            campo: columnaOriginal.campo,
            visible: true,
            ancho: columnaOriginal.ancho,
            orden: index
        }
        columnas.push(columna);
    });

    let definicionif={
            codigo: 0,
            columns: columnas,
            alto: alto,
            ifid: ifid,
    }
    return definicionif;
}

// Guardamos la configuración en la base de datos
// Devolvemos las nuevasColumnas
export const saveConfiguracion = (ifid, usuario, columnasEstado, alto, definicionifOriginal) => {
    const url= servidor  + "completo/restful/Definicionif/" + usuario.codigo;
    const clienteRestful = new ClienteRestful().setUrl(url);

    //Quitamos los campos que no ncesitamos guardar que se usan solo a nivel d interface de ConfiguracionGrd
    columnasEstado.forEach( (columnaEstado) =>{
        delete columnaEstado.titulo;
        delete columnaEstado.visibilidad;
    });
    const columnas= JSON.stringify(columnasEstado);
    let newDefinicionif= {};
    if  (definicionifOriginal){
        newDefinicionif= {...definicionifOriginal}
        newDefinicionif.columns= columnas;
        newDefinicionif.alto= alto;
        newDefinicionif.usuarioCodigo= usuario; //Hace falta para poder guardar.
    }
    else{
        newDefinicionif= {codigo: 0, ifid: ifid, columns: columnas, alto: alto, usuarioCodigo: usuario };
    }
    clienteRestful.doPost( newDefinicionif,
        response => {
                    if (clienteRestful.exito && response){
                    }
                 },
            responseError => {
                console.log("ERROR: ", responseError)
            }
    );

}

